import React from "react";
import { Phone, Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Why Us", href: "#why" },
  { label: "Estimate", href: "#estimate" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      className="sticky top-0 z-40 glass border-b border-blue-900/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2" data-testid="header-logo">
          <img
            src="/brand/logo.png"
            alt="Faithfully Clean — Pressure Washing & Exterior Cleaning"
            className="h-14 sm:h-16 w-auto object-contain"
            draggable={false}
          />
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="primary-nav">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[15px] font-bold text-slate-700 hover:text-[var(--fc-blue)] transition-colors"
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:4073752862"
            className="hidden sm:inline-flex items-center gap-2 btn-orange font-heading font-bold uppercase tracking-wide px-5 h-12 rounded-full transition-all"
            data-testid="header-call-cta"
          >
            <Phone className="w-4 h-4" />
            407-375-2862
          </a>
          <button
            className="md:hidden p-2 rounded-lg border border-slate-200"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="px-4 py-3 flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 font-bold text-slate-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:4073752862"
              className="mt-2 inline-flex justify-center items-center gap-2 btn-orange font-heading font-bold uppercase tracking-wide h-12 rounded-full"
              data-testid="mobile-call-cta"
            >
              <Phone className="w-4 h-4" /> 407-375-2862
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
